<template>
	<div v-loading="father_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<div class="title">
			<div id="notice">
				<h5>花名册&nbsp;&nbsp;说明:</h5><br>
				<span>1、查询关键字:账号、姓名、身份证、地址、电话。</span><br>
				<span>2、人员状态:兼职|长期。</span><br>
				<span>3、兼职人员:限定兼职开始日期和截止日期。</span><br>
				<span>4、工资计算:a、必须符合对应日期范围;b、实际发放=基本工资+岗位工资+交通补贴+餐补贴+话补贴+考勤奖惩-住房公积金-保险费用-借款+绩效。</span><br>
				<span>5、2021-11-25新增:a、花名册只能有管理员(固定负责人)查看,非负责人只能看自己的。b、除了管理员其他人不能修改。</span>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button @click="edit_mode">导入新增用户信息</button>
			</template>
		</pre-base>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',

				t_data: [],

				father_loading:false
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "person_data",
					"isTwo": "0",
					"action_flag": "longlong",
					"isFileMain": "1",
					"sel_action": 'exp_kq_user_exp',
					"upd_action": 'exp50_user_exp',
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "用户账号",
							"val": "",
							"key": "u_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "用户姓名",
							"val": "",
							"key": "u_name",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "身份证号码",
							"val": "",
							"key": "u_code",
							"type": "text",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "在职状态",
							"val": "",
							"key": "list_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_userclass",
							"sel_name": "",
							"sel": "4"
						},
						{
							"name": "电话",
							"val": "",
							"key": "u_tel",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_dep",
							"sel_name": "",
							"sel": "6"
						}
					],
					"parm": [{
							"name": "编号",
							"val": "",
							"key": "u_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1"
						},
						{
							"name": "姓名",
							"val": "",
							"key": "u_name",
							"type": "text",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "1"
						},
						{
							"name": "电话",
							"val": "",
							"key": "u_phone",
							"type": "number",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "1"
						},
						{
							"name": "角色",
							"val": "",
							"key": "rname",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_role",
							"sel_name": "",
							"weight": "1",
							"p": "1",
							"x": "2"
						},
						{
							"name": "部门",
							"val": "",
							"key": "dname",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_dep",
							"sel_name": "",
							"weight": "1",
							"p": "1",
							"x": "2"
						},
						{
							"name": "身份证号码",
							"val": "",
							"key": "sfz_no",
							"type": "text",
							"class": "long2",
							"p": "1",
							"x": "3"
						},
						{
							"name": "身份证住址",
							"val": "",
							"key": "sfz_address",
							"type": "text",
							"class": "long3",
							"p": "1",
							"x": "3"
						},
						{
							"name": "现住址",
							"val": "",
							"key": "now_address",
							"type": "text",
							"class": "long4",
							"p": "1",
							"x": "3"
						},
						{
							"name": "紧急联系人",
							"val": "",
							"key": "super_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "紧急联系电话",
							"val": "",
							"key": "super_phone",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "兼职开始",
							"val": "",
							"key": "s_partjop_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "5"
						},
						{
							"name": "兼职截止",
							"val": "",
							"key": "e_partjop_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "5"
						},
						{
							"name": "在职状态",
							"val": "",
							"key": "jop_type",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_userclass",
							"sel_name": "",
							"w": "1",
							"p": "1",
							"x": "5"
						},
						{
							"name": "入职日期",
							"val": "",
							"key": "jop_in",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "劳动合同编号",
							"val": "",
							"key": "jop_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "劳动合同开始",
							"val": "",
							"key": "jop_start",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "劳动合同结束",
							"val": "",
							"key": "jop_end",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "试用开始",
							"val": "",
							"key": "test_start",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "试用结束",
							"val": "",
							"key": "test_end",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "转正日期",
							"val": "",
							"key": "jop_begin",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "签署日期",
							"val": "",
							"key": "begin_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "6"
						},
						{
							"name": "总工资",
							"val": "",
							"key": "amount_all",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "7",
							"r": "1"
						},
						{
							"name": "基本工资",
							"val": "",
							"key": "s_base",
							"type": "number",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "岗位绩效",
							"val": "",
							"key": "s_role",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "交通补贴",
							"val": "",
							"key": "s_butie",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "餐补贴",
							"val": "",
							"key": "can_butie",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "话补贴",
							"val": "",
							"key": "hua_butie",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "考勤奖励",
							"val": "",
							"key": "record",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "住房公积金",
							"val": "",
							"key": "zhufang_gjj",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "社保补贴",
							"val": "",
							"key": "shebao_butie",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "安全奖",
							"val": "",
							"key": "anquanjiang",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						},
						{
							"name": "保险开始",
							"val": "",
							"key": "bx_s_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "8"
						},
						{
							"name": "保险截止",
							"val": "",
							"key": "bx_e_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "8"
						},
						{
							"name": "保险费用",
							"val": "",
							"key": "bx_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "8"
						},
						{
							"name": "保险名称",
							"val": "",
							"key": "bx_id",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_baoxian",
							"sel_name": "",
							"sel_name": "",
							"p": "1",
							"x": "8"
						},
						{
							"name": "毕业院校",
							"val": "",
							"key": "school",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "9"
						},
						{
							"name": "专业",
							"val": "",
							"key": "study",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "9"
						},
						{
							"name": "驾驶证有效",
							"val": "",
							"key": "car_start",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "9"
						},
						{
							"name": "驾驶证截至",
							"val": "",
							"key": "car_end",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "9"
						},
						{
							"name": "从业开始",
							"val": "",
							"key": "work_start",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "9"
						},
						{
							"name": "从业结束",
							"val": "",
							"key": "work_end",
							"type": "date",
							"class": "long1",
							"p": "1",
							"x": "9"
						},
						{
							"name": "其他证书",
							"val": "",
							"key": "other_card",
							"type": "text",
							"class": "long2",
							"p": "1",
							"x": "9"
						},
						{
							"name": "银行账号",
							"val": "",
							"key": "yh_no",
							"type": "text",
							"class": "long2",
							"p": "1",
							"x": "10"
						},
						{
							"name": "开户行信息",
							"val": "",
							"key": "yh_data",
							"type": "text",
							"class": "long2",
							"p": "1",
							"x": "10"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"x": "10"
						},
						{
							"name": "工龄工资",
							"val": "",
							"key": "gongling",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "7"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "账号"
						},
						{
							"name": "姓名"
						},
						{
							"name": "状态"
						},
						{
							"name": "在职状态"
						},
						{
							"name": "电话"
						},
						{
							"name": "部门"
						},
						{
							"name": "角色"
						},
						{
							"name": "身份证号码"
						},
						{
							"name": "身份证住址"
						},
						{
							"name": "现住址"
						},
						{
							"name": "紧急联系人"
						},
						{
							"name": "紧急联系电话"
						},
						{
							"name": "兼职开始日期"
						},
						{
							"name": "兼职截止日期"
						},

						{
							"name": "入职日期"
						},
						{
							"name": "劳动合同编号"
						},
						{
							"name": "劳动合同开始"
						},
						{
							"name": "劳动合同结束"
						},
						{
							"name": "试用期开始"
						},
						{
							"name": "试用期结束"
						},
						{
							"name": "转正日期"
						},
						{
							"name": "签署日期"
						},
						{
							"name": "总工资"
						},
						{
							"name": "基本工资"
						},
						{
							"name": "岗位工资"
						},
						{
							"name": "交通补贴"
						},
						{
							"name": "餐补贴"
						},
						{
							"name": "话补贴"
						},
						{
							"name": "考勤奖罚"
						},
						{
							"name": "住房公积金"
						},
						{
							"name": "社保补贴"
						},
						{
							"name": "安全奖"
						},
						{
							"name": "工龄工资"
						},
						{
							"name": "保险开始"
						},
						{
							"name": "保险截止"
						},
						{
							"name": "保险费用"
						},
						{
							"name": "保险名称"
						},
						{
							"name": "毕业院校"
						},
						{
							"name": "专业"
						},
						{
							"name": "驾驶证有效"
						},
						{
							"name": "驾驶证截至"
						},
						{
							"name": "从业开始"
						},
						{
							"name": "从业结束"
						},
						{
							"name": "其他证书"
						},
						{
							"name": "银行账号"
						},
						{
							"name": "开户信息"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data();
				});
			},
			refresh_father: function(type, val, item) {
				console.log(' 刷新父 type=' + type + ' val=' + val);
				this.row_id = val;
				this.t_data = item;
			},
			/*****************************************************/
			edit_mode: function() {
				this.father_loading = true;				
				this.$post(
				  api.http_method, Method_Common('kq_user_build',0,'',[])
				).then(res => {
				  this.father_loading = false;
				  console.log(res);
				  res = JSON.parse(res);
				  console.log(res);
				  if (res.data.status == 1) {
				    this.$message({
				      message: res.data.msg,
				      type: 'success'
				    });
				
				    this.refresh_data();
				
				  } else {
				    this.$message({
				      message: res.data.msg,
				      type: 'warning'
				    });
				  }
				});				
			}


		}
	};
</script>
<style scoped>

</style>